import React from 'react'
import PropTypes from 'prop-types'
import TpaLearningCenterConsent from 'hec/components/tpa-learning-center-consent/tpaLearningCenterConsent'
import {useToast} from '@/hooks/useToast'
import {useIntl} from 'react-intl'
import LoadingSpinner from '~/app/components/loading-spinner'
import {API_ERROR_MESSAGE} from '@salesforce/retail-react-app/app/constants'

import {useFetchOneEntry} from 'hec/hooks/useFetchOneEntry'
import modelMap from 'hec/builder/model-map'

/**
 * Builder block for TPA Learning Center Consent
 * Receives props from Builder and passes them to the view component.
 */
export const BuilderTpaLearningCenterConsent = ({attributes, 'data-testid': dataTestId}) => {
    // Fetch the Builder.io entry for the consent modal
    const {data, isLoading, error} = useFetchOneEntry({
        queryKey: ['tpaLearningCenterConsent', 'default'],
        options: {
            model: modelMap.tpaLearningCenterConsent, // resolves to 'tpa-learning-center-consent'
            options: {name: 'default'}
        }
    })

    const showToast = useToast()
    const {formatMessage} = useIntl()

    if (isLoading) {
        return <LoadingSpinner data-testid="productItem-LoadingSpinner" />
    }

    const showError = () => {
        showToast({
            title: formatMessage(API_ERROR_MESSAGE),
            status: 'TPA-LC-Error'
        })
    }

    if (error || !data) {
        showError()
    }

    const {className, ...restAttributes} = attributes || {}

    return (
        <TpaLearningCenterConsent
            modalContent={data.data?.modalContent || ''}
            className={className}
            {...restAttributes}
            data-testid={dataTestId || 'tpaLearningCenterConsent-Block'}
        />
    )
}

BuilderTpaLearningCenterConsent.propTypes = {
    modalContent: PropTypes.string,
    attributes: PropTypes.any,
    'data-testid': PropTypes.string
}

export const TpaLearningCenterConsentDefinition = {
    component: BuilderTpaLearningCenterConsent,
    name: 'TpaLearningCenterConsent',
    noWrap: true,
    inputs: [
        {
            name: 'modalContent',
            type: 'html',
            required: true,
            helperText: 'Paste HTML, embed, or script code here.'
        }
    ]
}
